import { CircularProgress, Stack } from '@mui/material';
import { useEffect, useState } from "react";
import Typewriter from 'typewriter-effect';
import Header from "../components/header";
import InteractionModel, { InteractionAuthor } from "../data/InteractionModel";
import { SignupModelHelper } from "../data/SignupModel";
import { nationalities } from '../data/nationalities';
import AmarelinhoService from '../services/AmarelinhoService';
import { AmplitudeService } from '../services/AmplitudeService';

export default function Nacionalidade(props: any) {

  const [lastAnswer, setLastAnswer] = useState('');

  const [loading, setLoading] = useState(false);

  const [typed, setTyped] = useState(false);
  const [interactions, setInteractions] = useState<InteractionModel[]>([]);

  useEffect(() => {
    SignupModelHelper.checkLogin().then(async (userId) => {
      if (!userId) {
        document.location = '#/';
      }
    });
    const signup = SignupModelHelper.get();
    if (signup) {
      setLastAnswer(signup.maritalStatus.description);
    } else {
      document.location = '#/';
    }

    // TagManager.dataLayer(dataLayerHelper.pagina('nacionalidade', 'curriculo'));
    AmplitudeService.track('Nationality Screen')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function updateNationality(nationality: string) {
    SignupModelHelper.update({ nationality });
    // fazer requisição de atualização dos dados pessoais do currículo
    const signup = SignupModelHelper.get()!;

    const chat = [...interactions, {
      text: nationality,
      author: InteractionAuthor.CLIENTE
    }];
    setInteractions(chat);
    setLoading(true);
    AmarelinhoService.saveExtraPersonalData(signup).then((result) => {

      if (result.success) {
        AmplitudeService.track('Nationality Submit', { country: nationality })
        document.location = '#/pretensao-salarial';
      } else {

        setTimeout(() => {
          setInteractions([...chat, {
            author: InteractionAuthor.AMARELINHO,
            text: 'Estou com problemas para salvar suas informações pessoais. Favor tente mais tarde.'
          }])
          setTimeout(() => {
            setTyped(true);
            let chat = document.getElementsByClassName('chat')[0];
            chat.scrollTo(0, chat.scrollHeight);
          }, 500);
        }, 1000);
      }

      setLoading(false);
    });
  }

  return (
    <>
      <Header step={ 3 } total={ 3 } title="Sua nacionalidade" previous="#/estado-civil"></Header>
      <div className="chat-container">
        <div className="chat">
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-stretch justify-content-between">

                <div className="chat-item chat-item-user">
                  <img src="images/ico-chat-user.svg" alt="Usuário" />
                  <div className="chat-item-content">
                    <p>{ lastAnswer }</p>
                  </div>
                </div>

                <div className="chat-item">
                  <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                  <div className="chat-item-content">
                    <Typewriter
                      onInit={ (typewriter) => {
                        typewriter
                          .changeDelay(15)
                          .typeString(`Qual é a sua nacionalidade?`)
                          .callFunction(() => {
                            setTyped(true)
                          })
                          .start();
                      } }
                    />
                  </div>
                </div>

                {
                  interactions.map((interaction) => {
                    let objRet;

                    if (interaction.author === InteractionAuthor.AMARELINHO) {
                      objRet = <div className="chat-item" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-amarelinho.svg" alt="Amarelinho" />
                        <div className="chat-item-content">
                          <Typewriter
                            onInit={ (typewriter) => {
                              typewriter.changeDelay(15).typeString(interaction.text)
                                .start();
                            } } />
                        </div>
                      </div>

                    } else if (interaction.author === InteractionAuthor.CLIENTE) {
                      objRet = <div className="chat-item chat-item-user" key={ interactions.indexOf(interaction) }>
                        <img src="images/ico-chat-user.svg" alt="Usuário" />
                        <div className="chat-item-content">
                          <p>{ interaction.text }</p>
                        </div>
                      </div>
                    }

                    return objRet;
                  })
                }
              </div>
            </div>
          </div>
        </div>

        { (typed || loading) &&
          <footer className="footer-answer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-answer-holder d-flex align-items-center justify-content-between">
                    { loading &&
                      <>
                        <Stack sx={ { color: '#6F5192' } } justifyContent="center" alignItems="center">
                          <CircularProgress color="inherit" />
                        </Stack>
                      </>
                    }
                    { !loading && typed && (
                      <>
                        <select name="" className="select select-hidden" id="maritalStatus" onChange={ (e) => updateNationality(e.target.value) } >
                          <option>Escolha uma nacionalidade</option>
                          {
                            nationalities.map(nationality => (
                              <option key={ nationality } value={ nationality }>{ nationality }</option>
                            ))
                          }
                        </select>
                        <input type="text" name="" id="input" placeholder="Escolha uma opção" />
                        <button className="btn-submit" disabled >
                          <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0114286 20L24 10L0.0114286 0L0 7.77778L17.1429 10L0 12.2222L0.0114286 20Z"></path></svg>
                        </button>
                      </>
                    ) }
                  </div>
                </div>
              </div>
            </div>
          </footer>
        }
      </div>
    </>
  );
}

